import React, { useCallback, useEffect, useState } from "react";
import api from "utils/apiService";

import CheckTable from "components/CheckTable";
import CommercialRegisterChangeRequestsColumn from "data/CommercialRegisterChangeRequestsColumn";
import HeaderButtons from "./components/HeaderButtons";
import RequestTypeTabs from "./components/RequestTypeTabs";
import { useSearchParams } from "react-router-dom";

const requestTypeTitles = {
  commercialRegister: "طلبات تغيير السجل التجاري",
  supplierProfilePdf: "طلبات تغيير ملفات الموردين",
};

const Index = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  const status = searchParams.get("status") || "";
  const name = searchParams.get("name") || "";
  const phoneNumber = searchParams.get("phoneNumber") || "";
  const requestType =
    searchParams.get("requestType") === "supplierProfilePdf"
      ? "supplierProfilePdf"
      : "commercialRegister";

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/commercialRegisterChangeRequests?page=${page}&requestType=${requestType}${
          status ? `&status=${status}` : ""
        }${name ? `&name=${name}` : ""}${
          phoneNumber ? `&phoneNumber=${phoneNumber}` : ""
        }`
      );

      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setData({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  }, [page, phoneNumber, name, requestType, status]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <section className="mt-3">
      <RequestTypeTabs activeType={requestType} />
      <CheckTable
        tableData={data?.data}
        columnsData={CommercialRegisterChangeRequestsColumn(
          fetchData,
          requestType
        )}
        title={requestTypeTitles[requestType]}
        totalCount={data?.pagination?.totalDocs}
        loading={loading}
        extraComponent={<HeaderButtons />}
      />
    </section>
  );
};

export default Index;
